import React, { useEffect, useState } from "react";
import "../../css_files/Master/AddCustomerAddress.css";
import axios from "axios";
import getCookie from "../../api";
import axiosInstance from "../../api";

function AddCustomerAddress({
  addressindex,
  customeraddressdata,
  customerData,
  dispatch,
}) {
  const [States, setStates] = useState([]);
  const [Cities, setCities] = useState([]);

  useEffect(() => {
    axiosInstance
      .get(`${process.env.REACT_APP_API_URL}/api/StateandCities/GetAllStates`)
      .then((res) => {
        setStates(res.data.sort((a, b) => a.name.localeCompare(b.name)));
      })
      .catch(console.log);
    getCitiesbyState(customeraddressdata[addressindex].state);
  }, []);

  function getCitiesbyState(stateId) {
    axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}/api/StateandCities/GetCitiesByStateId/${stateId}`
      )
      .then((res) => {
        setCities(res.data.sort((a, b) => a.name.localeCompare(b.name)));
      })
      .catch(console.log);
  }

  return (
    <form className="add-customer-address">
      <blockquote style={{ flexDirection: "row", alignItems: "center" }}>
        <p>Customer Address </p>
        <button
          type="button"
          style={{ marginLeft: "auto" }}
          onClick={() => {
            dispatch({ type: "decrement", index: addressindex });
          }}
        >
          <i class="fa-solid fa-circle-minus"></i>
        </button>
        <button
          type="button"
          onClick={() => {
            dispatch({ type: "increment", index: addressindex });
          }}
        >
          <i class="fa-solid fa-circle-plus"></i>
        </button>
      </blockquote>
      <blockquote>
        <label>
          From{" "}
          <sup>
            <i class="fa-solid fa-asterisk" style={{ color: "red" }}></i>
          </sup>
        </label>
        <aside>
          <mark>
            <input
              type="radio"
              name="From"
              required
              checked={customeraddressdata[addressindex]?.from === "Indian"}
              onChange={() => {
                dispatch({
                  type: "field",
                  index: addressindex,
                  name: "from",
                  value: "Indian",
                });
              }}
            />
            <p>Indian</p>
          </mark>
          <mark>
            <input
              type="radio"
              name="From"
              required
              checked={customeraddressdata[addressindex]?.from === "Others"}
              onChange={() => {
                dispatch({
                  type: "field",
                  index: addressindex,
                  name: "from",
                  value: "Others",
                });
              }}
            />
            <p>Others</p>
          </mark>
        </aside>
      </blockquote>

      <blockquote>
        <label>
          Address Type{" "}
          <sup>
            <i class="fa-solid fa-asterisk" style={{ color: "red" }}></i>
          </sup>
        </label>
        <aside>
          <mark>
            <input
              type="radio"
              name="AddressType"
              checked={
                customeraddressdata[addressindex]?.addressType === "Office"
              }
              onChange={(e) => {
                dispatch({
                  type: "field",
                  index: addressindex,
                  name: "addressType",
                  value: "Office",
                });
              }}
              required
            />
            <p>Office</p>
          </mark>
          <mark>
            <input
              type="radio"
              name="AddressType"
              checked={
                customeraddressdata[addressindex]?.addressType === "Factory"
              }
              onChange={(e) => {
                dispatch({
                  type: "field",
                  index: addressindex,
                  name: "addressType",
                  value: "Factory",
                });
              }}
              required
            />
            <p>Factory</p>
          </mark>
        </aside>
      </blockquote>
      {customeraddressdata[addressindex]?.addressType !== "" && (
        <blockquote>
          <label>
            {customeraddressdata[addressindex]?.addressType} Name{" "}
            <sup>
              <i class="fa-solid fa-asterisk" style={{ color: "red" }}></i>
            </sup>
          </label>
          <input
            type="text"
            placeholder={`Enter ${customeraddressdata[addressindex]?.addressType} Name`}
            onChange={(e) => {
              dispatch({
                type: "field",
                index: addressindex,
                name:
                  customeraddressdata[addressindex]?.addressType === "Office"
                    ? "officeName"
                    : "factoryName",
                value: e.target.value,
              });
            }}
            onInput={(e) => {
              e.target.value = e.target.value.slice(0, 200);
            }}
            value={
              customeraddressdata[addressindex]?.addressType === "Office"
                ? customeraddressdata[addressindex]?.officeName
                : customeraddressdata[addressindex]?.factoryName
            }
            required
          />
        </blockquote>
      )}
      <blockquote>
        <label>
          Address Line 1{" "}
          <sup>
            <i class="fa-solid fa-asterisk" style={{ color: "red" }}></i>
          </sup>
        </label>
        <input
          type="text"
          placeholder="Enter Address Line 1 (Street Name) Maximum 200 Characters"
          required
          onChange={(e) => {
            dispatch({
              type: "field",
              index: addressindex,
              name: "address1",
              value: e.target.value,
            });
          }}
          onInput={(e) => {
            e.target.value = e.target.value.slice(0, 200);
          }}
          value={customeraddressdata[addressindex]?.address1}
        />
      </blockquote>
      <blockquote>
        <label>Address Line 2</label>
        <input
          type="text"
          placeholder="Enter Address Line 2 (LandMark, Flat/House Number/Name) Maximum 200 Characters"
          onChange={(e) => {
            dispatch({
              type: "field",
              index: addressindex,
              name: "address2",
              value: e.target.value,
            });
          }}
          onInput={(e) => {
            e.target.value = e.target.value.slice(0, 200);
          }}
          value={customeraddressdata[addressindex]?.address2}
        />
      </blockquote>
      <aside>
        <blockquote>
          <label>
            Country{" "}
            <sup>
              <i class="fa-solid fa-asterisk" style={{ color: "red" }}></i>
            </sup>
          </label>
          {customeraddressdata[addressindex]?.from === "Indian" ? (
            <select
              required
              onChange={(e) => {
                dispatch({
                  type: "field",
                  index: addressindex,
                  name: "country",
                  value: e.target.value,
                });
              }}
            >
              <option value="">Select Country</option>
              <option
                value="India"
                selected={customeraddressdata[addressindex].country === "India"}
              >
                India
              </option>
            </select>
          ) : (
            <input
              type="text"
              onInput={(e) => {
                e.target.value = e.target.value.slice(0, 20);
              }}
              placeholder="Enter Country"
              required
              onChange={(e) => {
                dispatch({
                  type: "field",
                  index: addressindex,
                  name: "country",
                  value: e.target.value,
                });
              }}
              value={customeraddressdata[addressindex]?.country}
            />
          )}
        </blockquote>
        <blockquote>
          <label>
            State{" "}
            <sup>
              <i class="fa-solid fa-asterisk" style={{ color: "red" }}></i>
            </sup>
          </label>
          {customeraddressdata[addressindex]?.from === "Indian" ? (
            <select
              required
              onChange={(e) => {
                dispatch({
                  type: "field",
                  index: addressindex,
                  name: "state",
                  value: e.target.value,
                });
                getCitiesbyState(e.target.value);
              }}
            >
              <option value="">Select State</option>
              {States.map((state) => (
                <option
                  value={state.id}
                  selected={
                    customeraddressdata[addressindex]?.state === state.id
                  }
                >
                  {state.name}
                </option>
              ))}
            </select>
          ) : (
            <input
              type="text"
              onInput={(e) => {
                e.target.value = e.target.value.slice(0, 20);
              }}
              placeholder="Enter State"
              required
              onChange={(e) => {
                dispatch({
                  type: "field",
                  index: addressindex,
                  name: "stateName",
                  value: e.target.value,
                });
              }}
              value={customeraddressdata[addressindex]?.stateName}
            />
          )}
        </blockquote>
      </aside>
      <aside>
        <blockquote>
          <label>
            City{" "}
            <sup>
              <i class="fa-solid fa-asterisk" style={{ color: "red" }}></i>
            </sup>
          </label>
          {customeraddressdata[addressindex]?.from === "Indian" ? (
            <select
              required
              onChange={(e) =>
                dispatch({
                  type: "field",
                  index: addressindex,
                  name: "city",
                  value: e.target.value,
                })
              }
            >
              <option value="">Select City</option>
              {Cities.map((city) => (
                <option
                  value={city.id}
                  selected={customeraddressdata[addressindex]?.city === city.id}
                >
                  {city.name}
                </option>
              ))}
            </select>
          ) : (
            <input
              type="text"
              onInput={(e) => {
                e.target.value = e.target.value.slice(0, 20);
              }}
              placeholder="Enter City"
              required
              onChange={(e) => {
                dispatch({
                  type: "field",
                  index: addressindex,
                  name: "cityName",
                  value: e.target.value,
                });
              }}
              value={customeraddressdata[addressindex]?.cityName}
            />
          )}
        </blockquote>
        <blockquote>
          <label>Pincode</label>
          <input
            type="number"
            placeholder="Enter Pin Code"
            onChange={(e) =>
              dispatch({
                type: "field",
                index: addressindex,
                name: "pincode",
                value: e.target.value,
              })
            }
            min={100000}
            max={999999}
            onInput={(e) => {
              e.target.value = e.target.value.replace(/\D/g, "").slice(0, 6);
            }}
            value={customeraddressdata[addressindex]?.pincode}
          />
        </blockquote>
      </aside>
      <aside>
        <blockquote>
          <label>Latitude</label>
          <input
            type="number"
            step="any"
            placeholder="Latitude (readonly)"
            readOnly
            value={customeraddressdata[addressindex]?.latitude}
          />
        </blockquote>
        <blockquote>
          <label>Longitude</label>
          <input
            type="number"
            step="any"
            placeholder="Longitude (readonly)"
            readOnly
            value={customeraddressdata[addressindex]?.longitude}
          />
        </blockquote>
      </aside>
    </form>
  );
}

export default AddCustomerAddress;
